import { http } from "@/utils/http";
import { ListSearchParam, ListSearchResult, ResponseResult } from "./common.d";
import { ItemRequired } from "@/utils/customTypes";
import {
  BusinessForm,
  BusinessFormParent,
  BusinessTree,
  BusinessTypeItem,
  SubTemplateItem,
  SystemFieldItem,
  TemplateHtmlData,
  TemplateItem
} from "./template.d";


/**
 * 查询业务表单的限制字段
 * @returns
 */
export const getBusinessFormLimit = (id: number) => {
  return http.request<ResponseResult<any[]>>("get", "/businessForm/getLimit", {
    params: { id }
  });
};
/**
 * 保存业务表单的限制字段
 * @returns
 */
export const fetchBusinessLimitSave = (id: number, items: any[]) => {
  return http.request<ResponseResult<any[]>>("post", "/businessForm/saveLimit", {
    data: { id, items }
  });
};
/**
 * 更新子组件到业务表单
 * @returns
 */
export const fetchSubTempAppley = (id: number) => {
  return http.request<ResponseResult<ListSearchResult<any>>>(
    "get",
    "/template/applyToBussiness/" + id
  );
};
/**
 * 查询表格是否存在
 * @returns
 */
export const fetchTableExist = (code: string) => {
  return http.request<ResponseResult<ListSearchResult<any>>>(
    "get",
    "/template/checkTable/" + code
  );
};
/**
 * 删除数据源数据
 * @returns
 */
export const fetchDeleteSubSource = (ids: string, code: string) => {
  return http.request<ResponseResult<ListSearchResult<any>>>(
    "post",
    "/template/deleteSubSource",
    { data: { ids, code } }
  );
};
/**
 * 查询模板数据源列表
 * @returns
 */
export const fetchSubSourceList = (data: any) => {
  return http.request<ResponseResult<ListSearchResult<any>>>(
    "post",
    "/template/subSourceList",
    { data }
  );
};
/**
 * 查询模板数据源详情
 * @returns
 */
export const fetchSubSourceDetail = (code: string) => {
  return http.request<ResponseResult<any>>(
    "get",
    "/template/subSourceDetail/" + code
  );
};
/**
 * 查询模板文件
 * @returns
 */
export const fetchTemplatePath = (id: string | number) => {
  return http.request<ResponseResult<TemplateHtmlData>>(
    "get",
    "/template/getTemplatePath/" + id
  );
};
/**
 * 保存模板文件的html数据
 * @returns
 */
export const fetchTemplateFileSave = (data: { id: number; html: string }) => {
  return http.request<ResponseResult<BusinessTypeItem[]>>(
    "post",
    "/template/saveTemplate",
    { data }
  );
};

/**
 * 通过模板id查询关联的业务类型数据
 * @returns
 */
export const fetchBusinessByTemplateId = (id: number) => {
  return http.request<
    ResponseResult<{ business: BusinessTypeItem[]; system: SystemFieldItem[], form: any[] }>
  >("get", "/template/getBusinessByTemplateId/" + id);
};
/**
 * 删除模板文件
 * @param ids 要删除的项
 * @returns
 */
export const fetchTemplateDelete = (ids: string) => {
  return http.request<ResponseResult<ListSearchResult<TemplateItem>>>(
    "post",
    "/template/templateDelete",
    { data: { ids } }
  );
};
/**
 * 复制业务类型
 * @param ids 要删除的项
 * @returns
 */
export const fetchBusinessCopy = (ids: string) => {
  return http.request<ResponseResult<ListSearchResult<TemplateItem>>>(
    "post",
    "/template/businessCopy",
    { data: { ids } }
  );
};
/**
 * 删除业务类型
 * @param ids 要删除的项
 * @returns
 */
export const fetchBusinessDelete = (ids: string) => {
  return http.request<ResponseResult<ListSearchResult<TemplateItem>>>(
    "post",
    "/template/businessDelete",
    { data: { ids } }
  );
};
/**
 * 复制表单组件
 * @param ids 要复制的项
 * @returns
 */
export const fetchSubCopy = (ids: string) => {
  return http.request<ResponseResult>(
    "post",
    "/template/copySubTemplate",
    { data: { ids } }
  );
};
/**
 * 删除表单组件
 * @param ids 要删除的项
 * @returns
 */
export const fetchSubDelete = (ids: string) => {
  return http.request<ResponseResult<ListSearchResult<TemplateItem>>>(
    "post",
    "/template/SubDelete",
    { data: { ids } }
  );
};
/**
 * 查询模板文件列表
 * @param data 查询数据
 * @returns
 */
export const fetchTemplateList = (data: ListSearchParam) => {
  return http.request<ResponseResult<ListSearchResult<TemplateItem>>>(
    "post",
    "/template/templateList",
    { data }
  );
};
/**
 * 新增模板文件
 * @returns
 */
export const fetchAddTemplate = (data: TemplateItem) => {
  return http.request<ResponseResult<TemplateItem>>(
    "post",
    "/template/addTemplate",
    { data }
  );
};
/**
 * 修改模板文件
 * @returns
 */
export const fetchUpdateTemplate = (data: ItemRequired<TemplateItem, "id">) => {
  return http.request<ResponseResult<TemplateItem>>(
    "post",
    "/template/updateTemplate",
    { data }
  );
};
/**
 * 查询业务表单
 * @returns
 */
export function fetchBusinessForm<T extends boolean>(
  parentId: number | string,
  withParent?: T
): Promise<ResponseResult<T extends true ? BusinessFormParent : BusinessForm>> {
  return http.request<ResponseResult<any>>(
    "get",
    "/template/getBusinessForm/" + parentId,
    { params: { withParent } }
  );
}
export const fetchBusinessFormRule = (id: number | string) => {
  return http.request<ResponseResult<any>>(
    "get",
    "/template/getFormRuleById/" + id
  );
}
/**
 * 保存业务表单
 * @returns
 */
export const fetchSaveBusinessForm = (data: BusinessForm) => {
  return http.request<ResponseResult<BusinessForm>>(
    "post",
    "/template/saveBusinessForm",
    { data }
  );
};
/**
 * 修改业务类型
 * @returns
 */
export const fetchUpdateBusiness = (data: BusinessTree) => {
  return http.request<ResponseResult<BusinessTree>>(
    "post",
    "/template/updateBusiness",
    { data }
  );
};
/**
 * 新增业务类型
 * @returns
 */
export const fetchAddBusiness = (data: BusinessTree) => {
  return http.request<ResponseResult<BusinessTree>>(
    "post",
    "/template/addBusiness",
    { data }
  );
};
/**
 * 查询业务类型树形数据
 * @returns
 */
export const fetchBusinessTree = (roleFilter?: number) => {
  return http.request<ResponseResult<BusinessTree[]>>(
    "get",
    "/template/businessTree",
    { params: { roleFilter } }
  );
};
/**
 * 批量复制模板
 * @returns
 */
export const fetchTemplateCopy = (ids: string) => {
  return http.request<ResponseResult<any>>(
    "post",
    "/template/templateCopy",
    { data: { ids } }
  );
};
/**
 * 查询自定义子组件所有字段
 * @returns
 */
export const fetchSubTemplateFields = (code: string) => {
  return http.request<ResponseResult<any>>(
    "get",
    "/template/subFileds/" + code
  );
};
/**
 * 查询自定义子组件列表
 * @param data 查询数据
 * @returns
 */
export const fetchSubTemplateList = (data: ListSearchParam) => {
  return http.request<ResponseResult<ListSearchResult<SubTemplateItem>>>(
    "post",
    "/template/sublist",
    { data }
  );
};
/**
 * 查询全部自定义组件
 * @param data 查询数据
 * @returns
 */
export const fetchSubTemplateSubitems = () => {
  return http.request<ResponseResult<SubTemplateItem[]>>(
    "post",
    "/template/subitems"
  );
};

/** 添加自定义组件 */
export const fetchAddSubTemplate = (data: SubTemplateItem) => {
  return http.request<ResponseResult<SubTemplateItem>>(
    "post",
    "/template/addsub",
    {
      data
    }
  );
};

/** 修改自定义组件 */
export const fetchUpdateSubTemplate = (
  data: ItemRequired<SubTemplateItem, "id">
) => {
  return http.request<ResponseResult<SubTemplateItem>>(
    "post",
    "/template/updatesub",
    {
      data
    }
  );
};
/** 通过id获取自定义组件 */
export const fetchSubTemplateById = (id: number) => {
  return http.request<ResponseResult<SubTemplateItem>>(
    "get",
    "/template/getSubById/" + id
  );
};
/** 通过code获取自定义组件 */
export const fetchSubTemplateByCode = (code: string) => {
  return http.request<ResponseResult<SubTemplateItem>>(
    "get",
    "/template/getSubByCode/" + code
  );
};
/** 获取所有自定义组件 */
export const fetchAllSubTemplate = () => {
  return http.request<ResponseResult<SubTemplateItem[]>>(
    "get",
    "/template/allSubtemplate"
  );
};
/** 添加自定义表单数据源 */
export const fetchAddSubSource = (code: string, data: any) => {
  return http.request<ResponseResult<any>>(
    "post",
    "/template/addSubSourceData",
    { data: { code, data } }
  );
};
/** 添加自定义表单数据源 */
export const fetchUpdateSubSource = (code: string, data: any) => {
  return http.request<ResponseResult<any>>(
    "post",
    "/template/updateSubSourceData",
    { data: { code, data } }
  );
};
/** 获取数据详情 */
export const fetchSubData = (code: string, id: number) => {
  return http.request<ResponseResult<any>>(
    "post",
    "/template/getSubDataById",
    { data: { code, id } }
  );
};
/** 修改表单搜索字段 */
export const fetchSubSearchFieldsUpdate = (code: string, fields: any[]) => {
  return http.request<ResponseResult<any>>(
    "post",
    "/template/saveSubSearchField",
    { data: { code, fields } }
  );
};
/** 获取表单搜索字段 */
export const fetchSubSearchFields = (code: string) => {
  return http.request<ResponseResult<any>>(
    "get",
    "/template/getSubSearchField/" + code
  );
};
/** 上传文件修改模板的文件 */
export const fetchUpdateTemplateFile = (templateId: string, filePath: string) => {
  return http.request<ResponseResult<any>>(
    "post",
    "/template/updateTemplateFile",
    { data: { templateId, filePath } }
  );
};
